import { render, staticRenderFns } from "./SaveForm.vue?vue&type=template&id=3362a74b&scoped=true&"
import script from "./SaveForm.vue?vue&type=script&lang=js&"
export * from "./SaveForm.vue?vue&type=script&lang=js&"
import style0 from "./SaveForm.vue?vue&type=style&index=0&id=3362a74b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3362a74b",
  null
  
)

export default component.exports